<div class="card m-2 text-center" role="region" aria-labelledby="footer-left">
    <div class="card-body d-flex justify-content-center" style="height: 200px; overflow: hidden;">
        <div *ngIf="topLeftLoading" class="row">
            <div class="col my-auto">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
        <div *ngIf="!topLeftLoading" class="caseload-content w-100">
            <div class="row caseload-metrics-row mx-0 w-100">
                <div class="col caseload-metric">
                    <span class="dash-label text-uppercase">{{'CASES' | translate}}</span>
                    <div class="caseload-chart-wrap">
                        <kendo-chart [transitions]="true">
                            <kendo-chart-area opacity="0"></kendo-chart-area>
                            <ng-template kendoChartDonutCenterTemplate>
                                <span class="dash-numeric-medium" title="{{totalCases}}">{{totalCases | roundNumber}}
                                </span>
                            </ng-template>
                            <kendo-chart-series>
                                <kendo-chart-series-item type="donut" [data]="caseData" [margin]="0" [padding]="0"
                                    [startAngle]="180" [holeSize]="40" categoryField="category" field="value"
                                    colorField="color">
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
                <div class="col caseload-metric">
                    <span class="dash-label text-uppercase">{{ 'TASKS' | translate:patientLabel }}</span>
                    <div class="caseload-chart-wrap">
                        <kendo-chart [transitions]="true">
                            <kendo-chart-area opacity="0"></kendo-chart-area>
                            <ng-template kendoChartDonutCenterTemplate>
                                <span class="dash-numeric-medium" title="{{totalTasks}}">{{totalTasks | roundNumber}}
                                </span>
                            </ng-template>
                            <kendo-chart-series>
                                <kendo-chart-series-item type="donut" [data]="taskData" [margin]="0" [padding]="0"
                                    [startAngle]="180" [holeSize]="40" categoryField="category" field="value"
                                    colorField="color">
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
                <div class="col caseload-metric">
                    <span class="dash-label text-uppercase">{{ 'MEMBER' | translate:patientLabel }}s</span>
                    <div class="caseload-chart-wrap">
                        <kendo-chart [transitions]="true">
                            <kendo-chart-area opacity="0"></kendo-chart-area>
                            <ng-template kendoChartDonutCenterTemplate>
                                <span class="dash-numeric-medium" title="{{totalPatients}}">{{totalPatients | roundNumber}}
                                </span>
                            </ng-template>
                            <kendo-chart-series>
                                <kendo-chart-series-item type="donut" [data]="patientData" [margin]="0" [padding]="0"
                                    [startAngle]="180" [holeSize]="40" categoryField="category" field="value"
                                    colorField="color">
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <h4 class="title-label text-uppercase" id="footer-left">{{'CASELOAD' | translate}}</h4>
    </div>
</div>